define({
    preview: [
        'Preview',
        'X',
        'C',
        'D',
        'S',
        'P',
        'RK'
    ],
    live: [
        'Live',
        'M',
        'N',
        'I',
        'PW',
        'T',
        'U'

    ],
    'final': [
        'Final',
        'O',
        'F',
        'Q',
        'R',
        'W'
    ],
    other: []
});
